import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config'; // Initialize i18n
import './index.css';
import './lib/debug'; // Initialize debug mode settings

const container = document.getElementById('root');

// Hide initial loader smoothly after React mounts
const hideInitialLoader = () => {
    const initialLoader = document.getElementById('initial-loader');
    if (initialLoader) {
        initialLoader.style.transition = 'opacity 0.3s ease-out';
        initialLoader.style.opacity = '0';
        setTimeout(() => {
            if (initialLoader.parentNode) {
                initialLoader.remove();
            }
        }, 300);
    }
    // Mark as mounted
    if (container) {
        container.setAttribute('data-react-mounted', 'true');
    }
};

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Hide initial loader after React has rendered
// Use double requestAnimationFrame to ensure React has started rendering
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        setTimeout(() => {
            hideInitialLoader();
        }, 50);
    });
});